import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLogo } from '../components/SiteLogo';
import { SiteFooter } from '../components/landing/SiteFooter';
const ACUITY_SCRIPT_SRC = 'https://embed.acuityscheduling.com/js/embed.js';
export function BookTour() {
  useEffect(() => {
    document.title = 'Book a Tour — Twenty Mile House';
    window.scrollTo(0, 0);

    // Load Acuity's embed script (handles auto-resizing of the calendar).
    document.querySelectorAll(`script[src="${ACUITY_SCRIPT_SRC}"]`).forEach(node => node.remove());
    const script = document.createElement('script');
    script.src = ACUITY_SCRIPT_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  // Acuity posts an "AcuityEvent" message after every booking (Custom Conversion Tracking).
  // Listen for it and send the couple to the thank-you page.
  useEffect(() => {
    function handleMessage(e: MessageEvent) {
      let d: unknown = e.data;
      try {
        if (typeof d === 'string') d = JSON.parse(d);
      } catch (x) {
        return;
      }
      if (d && typeof d === 'object' && (d as {
        event?: unknown;
      }).event === 'AcuityEvent') {
        window.location.href = 'https://weddings.twentymile-house.com/thank-you';
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-97" data-mp="310wzu4vj8kce">
      <header className="px-6 pt-6 md:px-10" data-id="element-98" data-mp="30zdjke9vm9am">
        <Link to="/book-tour" aria-label="Twenty Mile House" className="inline-block" data-id="element-99" data-mp="2w128y1brburc">
          <SiteLogo data-id="element-100" data-mp="2s19x9fr2h8hr" />
        </Link>
      </header>

      <main data-id="element-101" data-mp="2s2l1fgofci9e">
        <section className="mx-auto max-w-3xl px-6 pt-8 text-center md:pt-10" data-id="element-102" data-mp="2s2upgypwsfcg">
          <h1 className="font-heading text-[1.75rem] font-light uppercase leading-[1.25] tracking-[0.06em] text-logo md:text-[2rem]" data-id="element-103" data-mp="1ko9h6qiyv6ba">
            Schedule Your Virtual Tour
          </h1>
          <p className="mx-auto mt-4 font-body text-[15px] leading-relaxed text-ink/80" data-id="element-104" data-mp="1i31sfmnjbezt">
            We are so excited for your upcoming virtual tour. Please use the scheduling tool below
            to pick a time that works for you!
          </p>
        </section>

        <section className="mt-10 w-full px-4 pb-16 md:px-10" aria-label="Tour booking calendar" data-id="element-105" data-mp="1d2mg8yezodjf">
          <iframe src="https://app.acuityscheduling.com/schedule.php?owner=20909820&appointmentType=98927793" title="Schedule your virtual tour" width="100%" height="800" frameBorder="0" allow="payment" data-id="element-106" data-mp="zbr2p8tjp89i" />
        </section>
      </main>

      <SiteFooter data-id="element-107" data-mp="udplyujldl17" />
    </div>;
}